import CardHeaderWithImageAndName from '@/components/atoms/CardHeaderWithImageAndName';
import { Card, VStack } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import React, { PropsWithChildren } from 'react';
import DirectoryStarButton from './DirectoryStarButton';
import { DirectoryPersonKind } from '@/services/api/requests/directory-stars';

type Props = {
  pictureUrl?: string;
  pictureLink:
    | '/directory/provider/$providerId'
    | '/directory/member-care/$memberCareId'
    | '/directory/peer-support/$peerSupportId';
  routeParams: ({ providerId: string } | { memberCareId: string } | { peerSupportId: string }) & Record<string, string>;
  name: string;
  roleSubtitle?: string;
  star?: { kind: DirectoryPersonKind; id: string; starred: boolean };
};

const CARD_WIDTH = '295px';
const CARD_HEIGHT = '400px';

const DirectoryCardBase = ({
  pictureUrl,
  pictureLink,
  routeParams,
  name,
  roleSubtitle,
  star,
  children,
}: PropsWithChildren<Props>) => {
  const navigate = useNavigate();

  return (
    <Card
      className={star ? 'directory-person-card sentry-block' : undefined}
      size="sm"
      width={CARD_WIDTH}
      height={CARD_HEIGHT}
      variant={'elevated'}
      borderRadius={'8px'}
      padding={'20px'}
      shadow={'0px 0px 20px 0px rgba(0, 65, 121, 0.15)'}
      position="relative"
    >
      {star && <DirectoryStarButton {...star} />}
      <CardHeaderWithImageAndName
        onClick={() => navigate({ to: pictureLink, params: routeParams })}
        hasTooltip
        profilePicture={pictureUrl}
        name={name}
        nameSubtitle={roleSubtitle}
      />
      <VStack flex={1} gap={0}>{children}</VStack>
    </Card>
  );
};

export default DirectoryCardBase;
